import './NoDataFound.scss'
import React from 'react'
import { Stack, Typography } from '@mui/material'

function NoDataFound() {
  return (
    <Stack sx={{height: '50vh', width: '100%', background: '#fff'}} alignItems="center" justifyContent="center">
      <Typography
            className="ff-Roboto fw-regular fs-24"
            style={{ color: '#707070' }}
          >
           We couldn't find any data for your request
          </Typography>
    </Stack>
  )
}

export default NoDataFound